<template>
<div class="d-flex" id="wrapper">
  <SideBar />
  <div id="page-content-wrapper">
    <nav style="justify-content:flex-start;" class="navbar navbar-expand-lg navbar-light bg-light border-bottom floating">
      <div>
        <button class="btn btn-outline" id="menu-toggle" @click="sidebar"><span class="navbar-toggler-icon"></span>
        </button>

        <button style="color: rgba(0,0,0,.5);border-color: rgba(0,0,0,.1);" class="btn btn-outline navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
          <span style="padding-top:0.5em;"><i class="fas fa-user-alt"></i><span class="account-div"></span><i class="fas fa-angle-down"></i></span>
        </button>
      </div>
      <div class="d-flex">
          <!-- <i class="fas fa-home text-muted hover-cursor" @click="toPage('/dashboard')"></i> -->
          <p class="text-primary mb-0" style="cursor:pointer;" @click="toPage('/risk-management/history')">&nbsp;Riwayat Pengecekan</p>
          <p class="text-primary mb-0 hover-cursor">&nbsp; / Detail</p>
        </div>
      <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <ul class="navbar-nav ml-auto mt-2 mt-lg-0">
          <li class="nav-item dropdown">
            <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              {{ admin }}
            </a>
            <div class="dropdown-menu dropdown-menu-right" aria-labelledby="navbarDropdown">
              <a class="dropdown-item link" @click="toPage('/password')"> <i class="fas fa-cog"></i><span class="right-dropdown">Change Password</span></a>
              <a class="dropdown-item link" @click="handleLogout"><i class="fas fa-sign-out-alt"></i><span class="right-dropdown">Logout</span></a>
            </div>
          </li>
        </ul>
      </div>
    </nav>
    <div class="container-fluid mt-3" v-if="loadingTable == true">
      <div class="row justify-content-center">
        <div><img src="~@/assets/images/load-button.gif" /></div>
      </div>
    </div>
    <div class="container-fluid" v-if="calculationResult.score && loadingTable == false">
      <div class="row">
        <div class="col-md-12 grid-margin stretch-card card-div">
          <div class="container">
            <h5 class="card-title mb-2 font-weight-bold">Hasil Kalkulasi</h5>
            <h5 class="card-title mb-4">Tgl : {{createdAt}}</h5>
          </div>
          <div class="container">
            <div class="row align-items-center my-2">
              <div class="col-lg-6">
                Golongan Skor
              </div>
              <div class="col-lg-6 pl-0">
                {{calculationResult.score}}
              </div>
            </div>
            <div class="row align-items-center my-2">
              <div class="col-lg-6">
                Batas maksimal total aset
              </div>
              <div class="col-lg-6 pl-0">
                Rp {{calculationResult.assetLimit}}
              </div>
            </div>
            <div class="row align-items-center my-2">
              <div class="col-lg-6">
                Estimasi total aset sedang disewa
              </div>
              <div class="col-lg-6 pl-0">
                Rp {{calculationResult.assetRentingEst}}
              </div>
            </div>
            <div class="row align-items-center my-2">
              <div class="col-lg-6">
                Total aset sedang disewa
              </div>
              <div class="col-lg-6 pl-0">
                {{calculationResult.assetRenting}}
              </div>
            </div>
            <div class="row align-items-center my-2">
              <div class="col-lg-6">
                Maksimum durasi yang diberikan
              </div>
              <div class="col-lg-6 pl-0">
                {{calculationResult.durationMax}}
              </div>
            </div>
            <div class="row align-items-center my-2">
              <div class="col-lg-6">
                Status barang yang dapat disewakan
              </div>
              <div class="col-lg-6 pl-0">
                {{calculationResult.productStatus}}
              </div>
            </div>
            <div class="row align-items-center my-2">
              <div class="col-lg-6">
                Minimal deposit yang dibutuhkan
              </div>
              <div class="col-lg-6 pl-0">
                {{calculationResult.depositMin}}
              </div>
            </div>
            <div class="row align-items-center my-2">
              <div class="col-lg-6">
                Usia perusahaan
              </div>
              <div class="col-lg-6 pl-0">
                {{calculationResult.companyAge}}
              </div>
            </div>
            <div class="row align-items-center my-2">
              <div class="col-lg-6">
                Nilai kontrak yang belum dibayarkan
              </div>
              <div class="col-lg-6 pl-0">
                {{calculationResult.unpaidContract}}
              </div>
            </div>
            <div class="row align-items-center my-2">
              <div class="col-lg-12">
                Riwayat transaksi (6 bulan terakhir)
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container-fluid my-2" v-if="calculationResult.historyTransaction && loadingTable == false">
      <div class="container" v-for="(history,i) in calculationResult.historyTransaction" :key="`trxHist-${i}`">
        <h6 class="font-weight-bold my-3" v-if="history.transaction.length">{{history.companyName}}</h6>
        <div class="row flex-wrap px-2">
          <div class="col-md-4 px-2 mb-3" v-for="(trans,j) in history.transaction" :key="`${trans.transactionNo}-${j}`">
            <div class="col-lg-12 px-2 py-3 border rounded" style="min-height: 150px;">
              <div class="font-weight-bold mb-2">{{trans.transactionNo}} ({{trans.status}})</div>
              <div>Total Tagihan : {{trans.total}}</div>
              <div>Sisa Tagihan : {{trans.balanceDue}}</div>
              <div>Tgl. jatuh tempo : {{trans.dueDate}}</div>
              <div v-if="trans">
                <div v-for="(pay,k) in trans.paymentDate" :key="`trans-${k}`">Tgl. bayar : {{pay.date}} {{pay.transactionNo.split(' ')[2]}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import SideBar from '../SideBar'
export default {

  name: 'detailRiwayat',
  components: {
    SideBar
  },
  data() {
    return {
      calculationResult: {},
      createdAt: '',
      viewEmployee: true,
      loadingTable: false,
      admin: '',
      adminId: ''
    }
  },
  methods: {
    toPage(e) {
      this.$router.push(e)
    },
    async getDetail(id) {
      try {
        this.loadingTable = true
        const res = await this.$http.get(process.env.GET_SCORE_DETAIL + id, {
          headers: {
            "Asani-Token": localStorage.getItem("jwt")
          }
        })
        if (res.data.status == 200) {
          this.calculationResult = res.data.content.scoring
          this.createdAt = res.data.content.createdAt
          this.loadingTable = false
        } else if (res.data.status == 400) {
          swal("Sorry", response.data.message, "error", {
            button: "Ok",
          })
        }
      } catch (error) {
        this.loadingTable = false
        swal("Sorry", error.response.data.message, "error", {
          button: "Ok",
        }).then(v => {
          if(error.response.data.status == 401) {
            this.handleLogout()
          } else {
            window.location.reload()
          }
        })
      }
      // this.loadingTable = true
      // this.$http.get(process.env.GET_SCORE_DETAIL + id, {
      //     headers: {
      //       "Asani-Token": localStorage.getItem("jwt")
      //     }
      //   })
      //   .then(res => {
      //     console.log(res)
      //     this.calculationResult = res.data.content.scoring
      //     this.createdAt = res.data.content.createdAt
      //     this.loadingTable = false
      //   })
      //   .catch(err => {
      //     console.log(err)
      //     this.loadingTable = false
      //   })
    },
    sidebar() {
      $("#wrapper").toggleClass("toggled");
    },
    cekLogin() {
      if (localStorage.getItem('jwt') == null) {
        this.$router.push('/')
      }
    },
    async handleLogout() {
      try {
        const response = await this.$http.post(process.env.LOGOUT, {}, {
          headers: {
            'Asani-Token': localStorage.getItem('jwt')
          }
        })
        if (response.data.status !== 200) {
          swal("Sorry", response.data.message, "error", {
            button: "Ok",
          })
          return
        }

      } catch (error) {
        if(error.response.data.status != 401) {
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          })
          return
        }
      }
      localStorage.removeItem('jwt')
      localStorage.removeItem('admin_name')
      localStorage.removeItem('roles')
      localStorage.removeItem('user_email')
      localStorage.removeItem('admin_id')
      localStorage.removeItem('changeCatalogPermission')
      this.$router.push('/')
    },
    cekPermission() {
      this.permission = localStorage.getItem('roles').replace(/"/g, "").replace("[", "").replace("]", "").split(",")
      for (var i = 0; i < this.permission.length; i++) {
        if (this.permission[i] == '10') {
          this.viewEmployee = true
        }
      }
      if (this.viewEmployee == false) {
        this.$router.push('/')
      }
    },
  },
  async created() {
    this.admin = localStorage.getItem('admin_name')
    this.adminId = localStorage.getItem('admin_id')
    this.cekLogin()
    this.cekPermission()
    await this.getDetail(this.$route.params.id)
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/RiskManagement/detailRiwayat.vue